// const baseUrl = 'http://127.0.0.1:5000/v1';
// const downloadUrl = 'http://127.0.0.1:5000/v1';

// const baseUrl = 'http://47.116.214.226:8040/v1';
// const downloadUrl = 'http://47.116.214.226:8040/';

const baseUrl = process.env.API_BASE_URL || 'https://skimoapi.chipskill.com/v1';
const downloadUrl = process.env.API_DOWNLOAD_URL || 'https://skimoapi.chipskill.com/';

const errCode = {
  OK: 200, // 服务器成功返回用户请求的数据
  CREATED: 201, // [POST/PUT/PATCH]：用户新建或修改数据成功。
  Accepted: 202, // 表示一个请求已经进入后台排队（异步任务）
  NO_CONTENT: 204, // [DELETE]：用户删除数据成功。
  INVALID_REQUEST: 400, // [POST/PUT/PATCH]：用户发出的请求有错误，服务器没有进行新建或修改数据的操作
  Unauthorized: 401, // 表示用户没有权限（令牌、用户名、密码错误）。
  Forbidden: 403, // 表示用户得到授权（与401错误相对），但是访问是被禁止的。
  NOT_FOUND: 404, // 用户发出的请求针对的是不存在的记录，服务器没有进行操作，该操作是幂等的。
  Not_Acceptable: 406, // 用户请求的格式不可得（比如用户请求JSON格式，但是只有XML格式）。
  Gone: 410, // 用户请求的资源被永久删除，且不会再得到的。
  Unprocesable_entity: 422, // [POST/PUT/PATCH] 当创建一个对象时，发生一个验证错误。
  INTERNAL_SERVER_ERROR: 500, // 服务器发生错误，用户将无法判断发出的请求是否成功。
  HTTP_507_INSUFFICIENT_STORAGE: 507, // 服务器发生错误，用户将无法判断发出的请求是否成功。
  CUSTOM_ERROR: 510,
};

const roleConsts = {
  ORG: {
    value: 100,
    label: '单位',
  },
  ORG_PLAYER: {
    value: 1,
    label: '专业运动员',
  },
  PLAYER: {
    value: 2,
    label: '运动员',
  },
  TECH_OFFICER: {
    value: 3,
    label: '技术官员',
  },
};

const approveConsts = {
  PENDING: {
    value: 0,
    label: '待审核',
  },
  APPROVED: {
    value: 1,
    label: '审核通过',
  },
  REJECTED: {
    value: 2,
    label: '审核不通过',
  },
  AUTHORIZING: {
    value: 3,
    label: '待认证',
  },
};

const stateConsts = {
  PENDING: {
    value: 0,
    label: '未开始',
  },
  SIGN_STARTED: {
    value: 1,
    label: '正在报名',
  },
  SIGN_END: {
    value: 2,
    label: '报名结束',
  },
  GAME_STARTED: {
    value: 3,
    label: '正在比赛',
  },
  GAME_END: {
    value: 4,
    label: '比赛结束',
  },
};

export {
  baseUrl,
  downloadUrl,
  errCode,
  roleConsts,
  approveConsts,
  stateConsts,
};



// WEBPACK FOOTER //
// ./src/utils/consts.js